export interface CrmPostCatalogRequestDto {
  vehicleId: string;
  tariffIds: string[];
}
